import {DiscountModel, DiscountType, PriceModel} from "@/types/pricing"
import axios from "./productInstance"

export default async (
    priceModel: PriceModel,
    price: number,
    discount: number,
    discount_type: DiscountType,
    discount_model: DiscountModel,
    max_price_total: number,
    min_price_total: number,
    name: string,
) => {
    const payload = {
        "price_model": priceModel,
        "price": price,
        "discount": discount,
        "discount_type": discount_type,
        "discount_model": discount_model,
        "max_price_total": max_price_total,
        "min_price_total": min_price_total,
        "name": name,
    }
    //console.log(payload)
    try {
        const response: any = await axios.post(`/pricing/`, payload)
        return response.data
    } catch (error) {
        return null
    }
}
